module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/pond/Room_pond_03-layoutphoto_03.png";